import {
  PortalShadowType,
  PortalStyleConfig,
  ThemeColorSchemas,
  PortalClassStateOrMedia,
  PortalClassState,
} from '@nx-frontend/shared/types';
import { getClassNamePrefix, getColorSchemaPrefix } from './getTheme';

export function getShadowClassNames(
  themeColors: ThemeColorSchemas,
  { shadow: { className } }: PortalStyleConfig,
  type: PortalShadowType = PortalShadowType.MAIN,
  states: PortalClassStateOrMedia[] = []
): string[] {
  if (!className.length || className.includes('shadow-none')) {
    return [];
  }

  const state = getClassNamePrefix(states);

  const classNames: string[] = [...className];

  // Temporarily add theme variable names for design purposes
  if (typeof type === 'string') {
    classNames.push(['_THEME', ...states, type].join(':'));
  }

  if (states.includes(PortalClassState.HOVER)) {
    classNames.push('transition-shadow');
  }

  return themeColors.reduce((classNames, { schema, colors }) => {
    const {
      [type]: [color],
    } = colors;
    const prefix = getColorSchemaPrefix(schema) + state;
    classNames.push(`${prefix}shadow-${color}`);
    return classNames;
  }, classNames);
}
